"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cart = /** @class */ (function () {
    function Cart() {
    }
    Cart.getCustomization = function (cart, id, customizationKey) {
        var cartItem = cart.items.find(function (i) { return i._id === id; });
        if (cartItem) {
            return cartItem.customizations.find(function (c) { return c.key === customizationKey; });
        }
        return undefined;
    };
    Cart.getAmountOfProductInCart = function (cart, productId) {
        return cart.items.reduce(function (value, item) {
            if (item.product._id === productId) {
                return value + item.amount;
            }
            return value;
        }, 0);
    };
    return Cart;
}());
exports.default = Cart;
//# sourceMappingURL=Cart.js.map